import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new";
import {
    VALIDATION_CHECKED,
    VALIDATION_LABELS, VALIDATION_UNCHECKED
} from "../../../../../model2/automation/lib/custom-field-validation"
import {FieldAutomationConditionFormProps} from "../../../../render/automation-condition-form";

const options = _.map([
    VALIDATION_CHECKED,
    VALIDATION_UNCHECKED,
], value=>({
    value: value,
    label: _.get(VALIDATION_LABELS,value)
}))

const debug = false
// const debug = "CheckboxConditionForm"

export default class FieldCheckbox_AutomationConditionForm extends React.Component<any,any> {

    static propTypes = {
        config          : PropTypes.object,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationConditionFormProps) {
        super(props)

        this.state = {
            validationType  : _.get(props.config, 'validationType', VALIDATION_CHECKED),
        }
    }

    onChangeValidationType = (option:any) => {
        const validationType = option.value

        this.setState({
            validationType
        }, ()=>{
            this.props.onChangeCallback({validationType})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state, options)

        return (
            <div className="flex-row-left-top">
                <div className="label w-100">is</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {options}
                                  value                         = {this.state.validationType}
                                  popoverScrollContainerClasses = "max-h-200 max-w-300"
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeValidationType}/>
            </div>
        )
    }
}
